<template>
  <div class="screen-enter">
    <div class="logo">
      <!-- <img src="../../common/img/logo.svg"/> -->
    </div>
    <div class="screen_box">
      <div class="screen_content">
        <div class="screen_title">
          <p class="title">欢迎使用财道书院投屏</p> 
          <p class="tips">打开财道书院APP，在活动/资源详情页点击“投屏”按钮获取投屏码并输入到下方。</p>
        </div>
        <div class="input_size">
          <ul class="clearfix">
            <li v-for="item in 4" :key="item">
              <input type="text" :id="'code_'+item" :codeIndex="item" v-model="bindData[item]"  @focus="codeFocus($event)" @blur="codeBlur($event)" @keydown="codeKeydown($event)" @input="validateInput($event)">
            </li>
          </ul>
        </div>
        <div class="code_error">
          <div id="errormsg">{{errormsg}}</div>
        </div>
        <div style="display:none" >{{ exitsVal }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import EventHandler from '../../common/js/EventHandler'
export default {
  name: 'screenEnter',
  data () {
    return {
      ifExist:"",
      bindData:['','','',''],
      errormsg:"",
    }
  },
  methods:{
    codeFocus:function(e){
      $(e.currentTarget.parentElement).addClass('current')
      $(e.currentTarget.parentElement).siblings().removeClass('current')
    },
    codeBlur:function(e){
      $(e.currentTarget.parentElement).removeClass('current')
    },
    codeKeydown:function(e){
      var keyCode=parseInt(e.keyCode);
      e.target.value = ''
      if(keyCode == 8){
        var codeIndex = parseInt($(e.currentTarget).attr('codeIndex'));
        if(codeIndex > 1){
          $(".clearfix li input[codeIndex='"+(codeIndex-1)+"']").focus();
        }
      }
    },
    validateInput:function(e){
      var s = e.target.value;
      if(s.length>1){
        s = s.substring(0,1)
      }
      var re = /[a-zA-Z0-9]/;
      if(!re.test(s)){
        s='';
      }
      if(s.length<=0){
        $(e.currentTarget).val('');
      }else{
        $(e.currentTarget).val(s);
        var codeIndex=parseInt($(e.currentTarget).attr("codeIndex"));
        if(codeIndex<4){
          $(".clearfix li input[codeIndex='"+(codeIndex+1)+"']").focus();
        }else{
          $(".clearfix li input[codeIndex='"+codeIndex+"']").blur();
        }
      }
      return false;
    }
  },
  computed:{
    exitsVal:function(){
        this.ifExist= this.bindData.join("");
    }
  },
  mounted:function(){
    $(".input_size>ul>li").first().addClass('current');
    $(".input_size>ul>li").first().children().focus()
  },
  watch:{
      ifExist(newVal,oldVal){
            if(newVal.length == 4){
              //调用接口 验证输入投屏码是否正确
              var that = this;
              that.$http.get(this.baseURL+'/appscreen/openScreen?screenKey='+ newVal).then((res)=>{
                  if(res.data.status == "success"){
                    that.common.setCookie('userId',res.data.userId,30)
                    that.common.setCookie('activityId',res.data.activityId,30)
                    that.common.setCookie('type',res.data.type,30)
                    that.common.setCookie('screenKey',res.data.screenKey,30)
                    that.common.setCookie('ocId',res.data.ocId,30)
                    that.common.setCookie('channel',res.data.channel,30)
                    that.common.setCookie('Authorization',res.data.Authorization,30)
                    setTimeout(function(){
                      that.initLongConnection()
                    })
                    switch(res.data.type){
                      case 1:
                          this.$router.replace({path: '/screenIndex/signIn'})
                        break;
                      case 2:
                          this.$router.replace({path: '/screenIndex/vote'})
                        break;
                      case 3:
                          this.$router.replace({path: '/screenIndex/responder'})
                        break;
                      case 4:
                          // this.$router.replace({path: '/screenIndex/discuss'})
                          this.errormsg = '讨论活动暂不支持';
                        break;
                      case 5:
                          // this.$router.replace({path: '/screenIndex/pick'})
                          this.errormsg = '选人活动暂不支持';
                        break;
                      default:
                          this.errormsg = '活动暂不支持';
                        break;
                    }
                  }else{
                    this.errormsg="投屏码无效";                    
                  }
            })
            // if(newVal == 'deng'){
            //   this.$router.push({path: '/screenIndex'})
            // }
            }else{
              this.errormsg=""
            }
          }
      }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'screenEnter.scss'
</style>



// WEBPACK FOOTER //
// src/components/screenEnter/screenEnter.vue